function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.732 7.058l-9.5-5a.501.501 0 00-.464 0l-9.5 5A.498.498 0 002 7.5v2a.5.5 0 00.5.5H4v8h-.5a.5.5 0 00-.354.146l-1 1A.5.5 0 002 19.5v2.005a.496.496 0 00.5.495h19a.496.496 0 00.5-.495V19.5a.5.5 0 00-.146-.354l-1-1A.5.5 0 0020.5 18H20v-8h1.5a.5.5 0 00.5-.5v-2a.498.498 0 00-.268-.442zM5 10h2v8H5zm9 8v-8h2v8zm-1 0h-2v-8h2zm-3 0H8v-8h2zm11 1.707v1.298H3v-1.298L3.707 19h16.586zM19 18h-2v-8h2zm2-9H3V7.802l9-4.737 9 4.737z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));